import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-successfull',
  templateUrl: './successfull.component.html',
  styleUrls: ['./successfull.component.css']
})
export class SuccessfullComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  finishCheckin(){
    const $this = this;
    $this.router.navigate(['/end']);
  }

}
